import React from 'react';
import { BsPlusCircleDotted } from 'react-icons/bs';
import { createSection } from '../../../../services/operations/courseApi';
import updateUserLocalStorage from '../../../../utils/updateUserLocalStorage';
import { setViewCourseLoading } from '../../../../redux/slices/viewCourseSlice';
import { useDispatch } from 'react-redux';
import SectionCreateOrUpdateInputTemplate from './SectionCreateOrUpdateInputTemplate';

const CreateOrUpdateSection = ({
    moduleType,
    register,
    getValues,
    setValue,
    setBgBlurModal,
    courseId
}) => {
    const dispatch = useDispatch();
    const createSectionHandler = async () => {
        dispatch(setViewCourseLoading(true));
        const sectionName = getValues('sectionName');
        try {
            await createSection(sectionName, courseId);
            await updateUserLocalStorage(dispatch);
            setBgBlurModal(null);
        } catch (error) {
            console.log(error.message);
        } finally {
            dispatch(setViewCourseLoading(false));
        }
    };

    return (
        <div>
            <button
                className='p-2 mx-2 my-3 border mt-4 border-yellow-50 flex justify-center items-center gap-x-2 text-yellow-50 font-semibold hover:scale-95 transition-all duration-200'
                type='button'
                onClick={() => setBgBlurModal(
                    <SectionCreateOrUpdateInputTemplate
                        moduleType={moduleType}
                        register={register}
                        getValues={getValues}
                        setValue={setValue}
                        createSectionHandler={createSectionHandler}
                    />
                )}
            >
                Add New Section
                <BsPlusCircleDotted className='text-xl' />
            </button>
        </div>
    );
};

export default CreateOrUpdateSection;